import { QueryClient } from '@tanstack/react-query';

import { createStartupMaintenanceFilter } from './apiUtils/startupMaintenanceFilter';
import { users } from './users';

export const queryClient = new QueryClient();
export const startupMaintenanceFilter = createStartupMaintenanceFilter(
  queryClient,
  users.activeUser.queryKey,
);
